import { atom } from "recoil";

export const selectedVehicleAtom = atom({
  key: "selectedVehicleAtom",
  default: null,
});
